/*
 *  Newsletter Pop-up
 *    Provides scripts for the newsletter pop-up
 *
 *  Version:
 *    1.0.0 - 2019/07/04
 */

import $ from 'jquery';
import Cookies from 'js-cookie';
import { register, ShopifySection } from './../../sections/ShopifySection';

export const CONTAINER_SELECTOR = '[data-newsletter-popup]';
export const POPUP_SELECTOR = '[data-newsletter-popup-wrapper]';
export const CLOSE_SELECTOR = '[data-newsletter-popup-close]';
export const POPUP_DELAY_DATA = 'data-newsletter-popup-delay';
export const NEWSLETTER_UNDERLAY = '[data-newsletter-popup-underlay]';
export const NEWSLETTER_SUBMIT = '[data-newsletter-submit]';
export const POPUP_COOKIE = 'hide-popup';
export const CLASS_POPUP_OPEN = 'is-popup-open';

export class NewsletterPopup extends ShopifySection {
  constructor(container) {
    super(container);

    this.popupUnderlay = container.find(NEWSLETTER_UNDERLAY);
    this.popupTargets = [container,this.popupUnderlay,$('html,body')];
    this.delay = parseInt(container.attr(POPUP_DELAY_DATA));

    container.on('click touch', CLOSE_SELECTOR, e => this.onCloseClick(e));
    container.on('click', NEWSLETTER_SUBMIT, () => this.addCookie());
    container.on('click', NEWSLETTER_UNDERLAY, e => this.closeNewsletterPopup(e));

    this.onPopupCookie();
  }

  onPopupCookie() {
    if(Cookies.get(POPUP_COOKIE)) return;
    if (this.container.length) {
      // add 1 to the delay in-case the delay setting is set to zero
      let popupDelay = (this.delay + 1) * 1000;
      setTimeout(() => {
        this.onOpenNewsletterPopup();
      }, popupDelay);
    }
  }

  onCloseClick(e) {
    e.preventDefault();
    e.stopPropagation();

    this.closeNewsletterPopup();
  }

  onOpenNewsletterPopup() {
    this.popupTargets.forEach(e => e.addClass(CLASS_POPUP_OPEN));
  }

  addCookie() {
    Cookies.set(POPUP_COOKIE, true, { expires: 30 });
  }

  closeNewsletterPopup() {
    this.popupTargets.forEach(e => e.removeClass(CLASS_POPUP_OPEN));
    this.addCookie();
  }

  cancelEvent(e) {
    e.preventDefault(), e.stopPropagation();
    return true;
  }

  onClickOutside(e) {
    if(!this.container.hasClass(CLASS_POPUP_OPEN)) return; //Not visible?
    let check = this.container.find(e.target);
    if(check.length) return;
    this.cancelEvent(e);
    this.closeNewsletterPopup();
  }
}

register(CONTAINER_SELECTOR, NewsletterPopup);
